export default {"src":"/_next/static/media/twitter.7e28326f.svg","height":204,"width":248,"blurWidth":0,"blurHeight":0};